import { Injectable } from '@angular/core';
import { CookieService } from './cookie.service';


@Injectable({
  providedIn: 'root'
})
export class PointsAndLivesService {

  public static pointsBaseValue = 1000;

  public currentPoints = 0;
  public currentStreak = 0;
  public highestStreak = 0;
  public currentLives = 3;
  public correctAnswers = 0;
  public endScoreShown = false;

  constructor(private cookieService: CookieService) { }

  public SetNewGameValues(): void{
    this.currentPoints = 0;
    this.currentStreak = 0;
    this.currentLives = 3;
    this.correctAnswers = 0;
    this.highestStreak = 0;
    this.endScoreShown = false;
    this.SaveCurrentValues();
  }

  public HandleAnswer(correctAnswer: boolean = true): boolean {

    if (correctAnswer) {
      this.currentPoints += PointsAndLivesService.pointsBaseValue * (1 + (this.currentStreak / 10));
      this.currentStreak++;
      this.correctAnswers++;
      if (this.currentStreak > this.highestStreak) {
        this.highestStreak = this.currentStreak;
      }
    }
    else {
      this.currentStreak = 0;
      this.currentLives--;
    }
    this.SaveCurrentValues();

    return this.currentLives > 0;
  }

  public SetEndScoreShown(): void {
    this.endScoreShown = true;
    this.SaveCurrentValues();
  }

  ////  Cookie handlers  /////////////////////////////////////////////

  public CheckRelevantCookieData(): void {

    if (this.cookieService.GetCookieValue('currentPoints')) {
      this.currentPoints = parseInt(this.cookieService.GetCookieValue('currentPoints'), 10);
    }

    if (this.cookieService.GetCookieValue('currentStreak')) {
      this.currentStreak = parseInt(this.cookieService.GetCookieValue('currentStreak'), 10);
    }

    if (this.cookieService.GetCookieValue('currentLives')) {
      this.currentLives = parseInt(this.cookieService.GetCookieValue('currentLives'), 10);
    }

    if (this.cookieService.GetCookieValue('correctAnswers')) {
      this.correctAnswers = parseInt(this.cookieService.GetCookieValue('correctAnswers'), 10);
    }

    if (this.cookieService.GetCookieValue('highestStreak')) {
      this.highestStreak = parseInt(this.cookieService.GetCookieValue('highestStreak'), 10);
    }

    if (!this.endScoreShown){
      this.endScoreShown = this.cookieService.GetCookieValue('endScoreShown') === 'true';
    }

  }

  private SaveCurrentValues(): void {
    this.cookieService.SetCookieValue('currentPoints', this.currentPoints);
    this.cookieService.SetCookieValue('currentStreak', this.currentStreak);
    this.cookieService.SetCookieValue('currentLives', this.currentLives);
    this.cookieService.SetCookieValue('correctAnswers', this.correctAnswers);
    this.cookieService.SetCookieValue('highestStreak', this.highestStreak);
    this.cookieService.SetCookieValue('endScoreShown', this.endScoreShown);
  }

}
